import styled from "styled-components";

export const SessionExpiredModalStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 60px;
  /* min-height: 340px; */
  /* gap: 19px; */
  .desc {
    /* padding: 20px 22px; */
    font-size: 16px;
    font-weight: 400;
    text-align: center;
    width: 389px;
    margin-top: 10px;
  }
  .title {
    font-size: 24px;
    font-weight: 600;
    text-align: center;
    margin-top: 19px;
    /* padding: 20px 22px; */
  }
  .button {
    background-color: #428bca;
    margin-top: 26px;
    max-width: 96px;
    width: 100%;
    border-radius: 2px;
  }
`;
